// extracted by mini-css-extract-plugin
module.exports = {"navItem":"Sidebar_navItem__3X5D1","navItem__collapsed":"Sidebar_navItem__collapsed__gh6-x","navItem__active":"Sidebar_navItem__active__7lNVi"};